export const SCHEDULING_ROUTES = {
  __ROOT__: '/scheduling',
}
